import React, { useState, useEffect } from "react";
import "./SellerProfileAccount.css";
import avatarImg from "../../assets/avatar.jpg";
import profilepicture from "../../assets/profileicon.png";
import accountimg from "../../assets/account-img.png";
import marketingimg from "../../assets/m2.png";
import survimg from "../../assets/surv-img.png";
import logoutimg from "../../assets/logout-img.png";
import { Link } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef, useMemo } from "react";
import {
  defaultCountries,
  parseCountry,
  FlagImage,
} from "react-international-phone";
import "react-international-phone/style.css";

export default function SellerProfileAccount() {
  const token = localStorage.getItem("token");

  const [code, setCode] = useState("+966");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
    const [city, setCity] = useState("");
  const [country,setCountry] =useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
    const [preview, setPreview] = useState(avatarImg);
    const [imageFile, setImageFile] = useState(null);
    const dropdownRef = useRef(null);

const countries = useMemo(
  () => defaultCountries.map(parseCountry),
  []
);

const [isOpen, setIsOpen] = useState(false);
const [selectedIso2, setSelectedIso2] = useState("sa");
  

  // ================= GET PROFILE =================
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${BaseUrl}${SellerServicesUrl.ShowProfile}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = res.data.data;

        setName(data.name || "");
        setEmail(data.email || "");
        setAddress(data.location || "");
        setCity(data.city || "");
        setCountry(data.country || "");
        setPhone(data.phone || "");
        setCode(data.code_phone || "+966");
        const dialCode = String(data.code_phone || "966");

const matchedCountry = countries.find(
  (c) => c.dialCode === dialCode.replace("+", "")
);

if (matchedCountry) {
  setSelectedIso2(matchedCountry.iso2);
}
          if (data.image) setPreview(data.image);
              } catch (err) {
                console.error(err.response?.data || err);
                toast.error("فشل تحميل بيانات الحساب ❌");
              }
            
    };

    if (token) fetchProfile();
  }, [token]);

    // ================= Handle Image Upload =================
    const handleImageChange = (file) => {
      if (file) {
        if (preview && preview !== avatarImg) {
          URL.revokeObjectURL(preview); 
        }
        setImageFile(file);
        setPreview(URL.createObjectURL(file));
      }
    };
  
    useEffect(() => {
      return () => {
        if (preview && preview !== avatarImg) URL.revokeObjectURL(preview);
      };
    }, [preview]);
  
    // =====//
  // ================= VALIDATION =================
const validate = () => {
  const newErrors = {};

  if (!name.trim()) {
    newErrors.name = "يجب أن يكون على الأقل 3 أحرف";
  }

  if (!email.trim()) {
    newErrors.email = "البريد الإلكتروني مطلوب";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    newErrors.email = "البريد الإلكتروني غير صالح";
  }

  if (!phone.trim()) {
    newErrors.phone = "رقم الهاتف مطلوب";
  }
  if (!city.trim()) {
    newErrors.city = "المدينة مطلوبة";
  }
  if (!country.trim()) {
    newErrors.city = "الدولة مطلوبة";
  }


  if (!address.trim()) {
    newErrors.address = "العنوان مطلوب";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  // ================= UPDATE =================
  const handleUpdate = async () => {
    if (!validate()) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("location", address);
       formData.append("city", city);
      formData.append("country", country);
      formData.append("phone", phone);
      formData.append("code_phone", code);

      await axios.post(
        `${BaseUrl}${SellerServicesUrl.UpdateProfile}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("تم التحديث بنجاح ✅");

    } catch (err) {
      toast.error("حدث خطأ أثناء التحديث ❌");
    }

    setLoading(false);
  };

  return (
    <div className="profile-wrapper">
      <div className="container">
        <div className="row">

          {/* ================= SIDEBAR  ================= */}
          <div className="col-md-6 mt-5">
            <div className="marketing-sidebar">

              <button className="side-btn2 active text-white">
                <Link
                  to="/seller/sellerprofileaccount"
                  className="text-white text-decoration-none d-flex align-items-center"
                >
                  <img className="ps-3 sidebar-icon" src={profilepicture} alt="Profile" />
                  حسابي الشخصي
                </Link>
              </button>

              <button className="side-btn2">
                <Link to="/seller/sellerbankaccount" className="text-dark text-decoration-none">
                  <img className='ps-3' src={accountimg} alt="Bank" />
                  الحساب البنكي
                </Link>
              </button>

              <button className="side-btn2">
                <Link to="/seller/sellermarketingreferral" className="text-dark text-decoration-none">
                  <img className='ps-3' src={marketingimg} alt="Marketing" />
                  التسويق
                </Link>
              </button>

              <button className="side-btn2">
                <Link to="/seller/sellercontractpage" className="text-dark text-decoration-none">
                  <img className='ps-3' src={survimg} alt="Contracts" />
                  التقييم والعقود
                </Link>
              </button>

              <button className="side-btn2 logout">
                <Link to="/accounttype" className="text-white text-decoration-none">
                  <img className='ps-3' src={logoutimg} alt="Logout" />
                  تسجيل الخروج
                </Link>
              </button>

            </div>
          </div>

          {/* ================= PROFILE ================= */}
          <div className="col-md-6">
            <div className="profile-content">

              {/* <div className="profile-avatar-wrapper">
                <div className="avatar-circle">
                  <img src={avatarImg} className="profile-avatar" alt="avatar" />
                </div>
              </div> */}
     {/* Avatar */}
          <div className="profile-avatar-wrapper">
            <div className="profileavatar-circle">
              <img src={preview} className="profile-avatar" alt="avatar" />
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={(e) => handleImageChange(e.target.files[0])}
              />
              <button
                type="button"
                className="avatar-edit-btn"
                onClick={() => document.getElementById("fileInput").click()}
              >
                <i className="fa-solid fa-pen"></i>
              </button>
            </div>
          </div>
              <form className="profile-form">

                {/* NAME */}
                <div className="form-group">
                  <label className="fw-bolder mb-2">اسم المحل / البائع</label>
                  <input
                    className="form-input"
                    placeholder="ادخل اسم المستخدم"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {errors.name && <p className="text-danger">{errors.name}</p>}
                </div>

                {/* EMAIL */}
                <div className="form-group">
                  <label className="fw-bolder mb-2">البريد الإلكتروني</label>
                  <input
                    className="form-input"
                    placeholder="reem@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <p className="text-danger">{errors.email}</p>}
                </div>

                {/* ADDRESS */}
                <div className="form-group">
                  <label className="fw-bolder mb-2">العنوان</label>
                  <input
                    className="form-input"
                    placeholder="الرياض، السعودية"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  {errors.address && <p className="text-danger">{errors.address}</p>}
                </div>

                {/* PHONE */}
                <div className="form-group">
                  <label className="fw-bolder mb-2">رقم الهاتف</label>
                  {/* <div className="phone-row">
                    <input
                      type="tel"
                      className="phone-number-input"
                      placeholder="123 456 789"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    <select
                      className="country-code-input"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    >
                      <option value="+966">+966</option>
                      <option value="+20">+20</option>
                      <option value="+971">+971</option>
                      <option value="+962">+962</option>
                      <option value="+974">+974</option>
                    </select>
                  </div> */}
                  <div className="regphone-row">
  <div className="code-dropdown" ref={dropdownRef}>
    <button
      type="button"
      className="code-dropdown-btn"
      onClick={() => setIsOpen((v) => !v)}
    >
      <span className="code-flag">
        <FlagImage iso2={selectedIso2} />
      </span>

      <span className="code-dial">{code}</span>

      <span className="code-arrow">▾</span>
    </button>

    {isOpen && (
      <div className="code-dropdown-menu">
        {countries.map((c) => (
          <button
            type="button"
            key={c.iso2}
            className="code-item"
            onClick={() => {
              setSelectedIso2(c.iso2);
              setCode(`+${c.dialCode}`);
              setIsOpen(false);
            }}
          >
            <span className="code-flag">
              <FlagImage iso2={c.iso2} />
            </span>

            <span className="code-dial">
              +{c.dialCode}
            </span>

            <span className="code-name">
              {c.name}
            </span>
          </button>
        ))}
      </div>
    )}
  </div>

  <input
    type="tel"
    className="form-control phone-number-input text-end"
    placeholder="ادخل رقم الجوال"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
  />
</div>
                  {errors.phone && <p className="text-danger">{errors.phone}</p>}
                </div>

                {/* SAVE BUTTON */}
                <div className="save-wrapper">
                  <button
                    type="button"
                    className="save-btn"
                    onClick={handleUpdate}
                  >
                    {loading ? "جاري الحفظ..." : "حفظ"}
                  </button>
                </div>

              </form>

            </div>
          </div>

        </div>
      </div>

      <ToastContainer position="bottom-right" rtl />
    </div>
  );
}
